import { Components, Theme } from '@mui/material';

export const MuiCard = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 8,
      boxShadow: theme.shadows[1],
      border: '1px solid',
      borderColor: theme.palette.neutral.outlineVariant,
      '&:hover.clickable': {
        boxShadow: theme.shadows[2]
      },
      '&.success': {
        borderColor: theme.palette.success.outline,
        backgroundColor: theme.palette.success.container,
        color: theme.palette.success.onContainer
      },
      '&.error': {
        borderColor: theme.palette.error.outline,
        backgroundColor: theme.palette.error.container,
        color: theme.palette.error.onContainer
      }
    }),
  },
} as Components<Theme>['MuiCard'];

export const MuiCardContent = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(3),
      gap: theme.spacing(0.5),
      display: 'flex',
      flexDirection: 'column',
      '&.isCondensed': {
        padding: theme.spacing(2),
        gap: 'unset'
      }
    }),
  },
} as Components<Theme>['MuiCardContent'];

export const MuiCardHeader = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: '100%',
      padding: theme.spacing(0),
      alignItems: 'flex-start'
    }),
    content: ({ theme }) => ({
      flex: 1,
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1)
    }),
    avatar: ({ theme }) => ({
      marginRight: theme.spacing(1)
    }),
  },
} as Components<Theme>['MuiCardHeader'];